module.exports = __webpack_public_path__ + "assets/resstar1-1at2x.36b15b10e8e34f9e20f601fffcf66c50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/stars/resstar1-1at2x.png
// module id = 853
// module chunks = 0